// DESIGN V2 — what the era slider means at a given position. Mirrors the
// server's getDateRange bands (music-info-server/services/feedAssembler.js):
// relative windows, so the years roll forward on their own.
export const feedEraLabel = (v, now = new Date()) => {
    const y = (ago) => Math.round(now.getFullYear() + (now.getMonth() + 1) / 12 - ago);
    if (v > 0.71) return 'Last 12 months';
    if (v > 0.43) return `${y(6)}–${y(1)}`;
    if (v > 0.14) return `${y(10)}–${y(6)}`;
    if (v > -0.14) return `${y(12.5)}–${y(10)}`;
    if (v > -0.43) return `${y(15)}–${y(12.5)}`;
    if (v > -0.71) return `${y(20)}–${y(15)}`;
    return `Before ${y(20)}`;
};
